import { render } from "./Champ_Select_Document.vue?vue&type=template&id=afec9d36"
import script from "./Champ_Select_Document.vue?vue&type=script&lang=js"
export * from "./Champ_Select_Document.vue?vue&type=script&lang=js"

import "./Champ_Select_Document.vue?vue&type=style&index=0&id=afec9d36&lang=scss"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__